const awsconfig = {
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_AWS_CONFIG_USER_POOL_ID,
      userPoolClientId: process.env.REACT_APP_AWS_CONFIG_USER_POOL_CLIENT_ID,
      signUpVerificationMethod: process.env.REACT_APP_AWS_CONFIG_SIGN_UP_VERIFICATION_METHOD
    }
  }
};

export default awsconfig;